import { useParams } from "react-router";
import { CustomerAddressCard } from "@/services/backend/addresses/components/customer-address-card";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { ServiceAddressCard } from "@/services/backend/addresses/components/service-address-card";
import { ContactCard } from "@/services/backend/contacts/components/contact-card";
import { RepresentativeCard } from "@/services/backend/representatives/components/representative-card";
import { Confirmation } from "@/services/backend/htz/confirmations/types/confirmation";
import {
  PatchRequest,
  updateHtzConfirmationCache,
  useHtzConfirmationPatchMutation,
  useHtzConfirmationShowQuery,
} from "@/services/backend/htz/confirmations/api/confirmation-api";
import { useOptimisticDebouncedMutation } from "@/shared/lib/debounce/use-optimistic-debounced-mutation";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import t from "@/lang/lang";

export function AddressesAndContactsRoute() {
  const { confirmationId } = useParams();
  const { data, error, isLoading } = useHtzConfirmationShowQuery({
    id: confirmationId!,
  });

  return (
    <div>
      {data && <AddressesAndContacts data={data} />}
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
    </div>
  );
}

function AddressesAndContacts({ data }: { data: Confirmation }) {
  const request: PatchRequest = { id: data.id };
  const [set] = useOptimisticDebouncedMutation(
    request,
    updateHtzConfirmationCache,
    useHtzConfirmationPatchMutation(),
  );
  const disabled = isImmutable(data);

  return (
    <div className="grid gap-2 xl:grid-cols-2">
      <CustomerAddressCard
        customerAddress={data.postalAddress}
        onCustomerAddressChange={(postalAddress) =>
          set({ ...request, postalAddress }, { ...data, postalAddress })
        }
        description={t(
          "Adresse an welche das Auftragsbestätigung geschickt werden soll.",
        )}
        fieldName="postalAddress"
        disabled={disabled}
      />
      <ServiceAddressCard
        address={data.serviceAddress}
        onAddressChange={(serviceAddress) =>
          set({ ...request, serviceAddress }, { ...data, serviceAddress })
        }
        fieldName="serviceAddress"
        disabled={disabled}
      />
      <ContactCard
        contact={data.serviceContact}
        onContactChange={(serviceContact) =>
          set({ ...request, serviceContact }, { ...data, serviceContact })
        }
        fieldName="serviceContact"
        disabled={disabled}
      />
      <RepresentativeCard
        representative={data.representative}
        onRepresentativeChange={(representative) =>
          set({ ...request, representative }, { ...data, representative })
        }
        fieldName="representative"
        disabled={disabled}
      />
    </div>
  );
}
